import { render, staticRenderFns } from "./JCGoVerifyStep.vue?vue&type=template&id=1088ce3e&scoped=true&"
import script from "./JCGoVerifyStep.vue?vue&type=script&lang=js&"
export * from "./JCGoVerifyStep.vue?vue&type=script&lang=js&"
import style0 from "./JCGoVerifyStep.vue?vue&type=style&index=0&id=1088ce3e&prod&scoped=true&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1088ce3e",
  null
  
)

export default component.exports